import { useQuery } from '@tanstack/react-query';
import { usePrismAuth } from '@/lib/prism-bridge';
import { getAppInstallations } from './installations';
import { queryKeys } from './queryKeys';

/**
 * Installations of one app (GET /dev-portal/apps/{appId}/installations) across all
 * live shards. Org-scoped query key. Gated on `isReady` (token + org id both synced from
 * Prism) and the appId — firing before the org id lands would 400 and show an error/retry page.
 */
export function useAppInstallations(appId: string) {
  const { token, orgId, isReady } = usePrismAuth();
  return useQuery({
    queryKey: queryKeys.apps.installations(orgId, appId),
    queryFn: () => getAppInstallations({ token, orgId }, appId),
    enabled: isReady && Boolean(appId),
  });
}
